import Shimmer from 'Components/shimmer'
const ShimmerArticle = () => {
  return (
    <div className="card-shimmer">
      <div className='shimmer-wrapper'>
        <div className='image-shimmer'>
          <Shimmer height="280px" width="377px" />
        </div>
        <div className='shimmer-child-container'>
          <div className='tag'>
            <Shimmer height="12px" width="225px" />
          </div>
          <div className='title'>
            <Shimmer height="20px" width="100%" />
            <Shimmer height="20px" width="70%" />
            <Shimmer height="20px" width="100%" />
          </div>
          <div className='title content'>
            <Shimmer height="14px" width="50%" />
            <Shimmer height="14px" width="30%" />
            <Shimmer height="14px" width="40%" />
          </div>
          <div className='author'>
            <Shimmer height="14px" width="50%" />
          </div>
        </div>
      </div>
      <style jsx global>
        {`
          .fdn-shimmer {
            margin: 0px !important;
          }
        `}
      </style>
      <style jsx>
        {`
          .card-shimmer {
            max-width: 820px;
            border-bottom: 1px solid #dfe3e8;
            margin-bottom: 40px;
          }
          .shimmer-wrapper {
            display: grid;
            gap: 30px;
            grid-template-columns: 375px auto;
            margin-bottom: 20px;
            height: 290px;
            margin-bottom: 20px;
          }
          .image-shimmer {
            padding: 5px 0;
          }
          .tag {
            margin-bottom: 10px;
          }
          .title {
            display: flex;
            gap: 10px;
            flex-direction: column;
          }
          .title.content {
            margin-top: 10px;
          }
          .author {
            margin-top: 10px;
          }
        `}
      </style>
    </div>
  )
}

export default ShimmerArticle
